import { render, staticRenderFns } from "./UploadMultiple2.vue?vue&type=template&id=e158741e&scoped=true"
import script from "./UploadMultiple2.vue?vue&type=script&lang=js"
export * from "./UploadMultiple2.vue?vue&type=script&lang=js"
import style0 from "./UploadMultiple2.vue?vue&type=style&index=0&id=e158741e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e158741e",
  null
  
)

export default component.exports